export const ErrBadProjectPlatformCombo = 1;
export const ErrEmailAlreadyInUse = 2;
export const ErrNoAccountOrInvalidPassword = 3;
export const ErrMissingEmail = 4;
export const ErrMissingPassword = 5;
export const ErrUserAlreadyExist = 6
export const ErrInvalidNickName = 7;
export const ErrMissingPlatform = 8;
export const ErrMissingPlatformIdentifier = 9;
export const ErrPlatformIdentifierAlreadyRegisteredToAnotherEmail = 10;
export const ErrAccountAlreadyHasThisPlatform = 11;